import React from 'react';
import PropTypes from 'prop-types';
import getStatusCssClassModifierByStatus from './get_status_css_class_modifier_by_status';
import currentStatusFactory from './current_status/current_status_factory';
import missingStatusFactory from './missing_status/missing_status_factory';

const BASE_CLASS_NAME = 'statusbar';

function Statusbar({
    status,
    filters,
    onChangeSpecific,
    onAddMissingClick,
    onLearnMoreClick,
    postcodeExistsButNeedsToBeLoaded,
    displayDimensions,
}) {
    const classNameModifier = getStatusCssClassModifierByStatus(status);
    const classNames = [BASE_CLASS_NAME];
    if ('' !== classNameModifier) {
        classNames.push(BASE_CLASS_NAME + classNameModifier);
    }

    return (
        <div className={classNames.join(' ')}>
            <div>
                {currentStatusFactory(status, filters, postcodeExistsButNeedsToBeLoaded, displayDimensions, onChangeSpecific)}
                {' '}
                {missingStatusFactory(status, filters, postcodeExistsButNeedsToBeLoaded, onAddMissingClick, onLearnMoreClick, onChangeSpecific)}
            </div>
        </div>
    );
}

Statusbar.propTypes = {
    status: PropTypes.string.isRequired,
    filters: PropTypes.object.isRequired,
    postcodeExistsButNeedsToBeLoaded: PropTypes.bool.isRequired,
    onChangeSpecific: PropTypes.func.isRequired,
    onAddMissingClick: PropTypes.func.isRequired,
    onLearnMoreClick: PropTypes.func.isRequired,
    displayDimensions: PropTypes.string,
};

Statusbar.defaultProps = {
    displayDimensions: '',
};


export default Statusbar;
